/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcQuestionCircleSmallRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12 8.9c-.461 0-.878.392-.878.929a.9.9 0 0 1-1.8 0C9.322 8.346 10.497 7.1 12 7.1s2.677 1.246 2.677 2.729a2.74 2.74 0 0 1-1.242 2.304 2 2 0 0 0-.446.367.5.5 0 0 0-.08.12.1.1 0 0 0-.01.037v.232a.9.9 0 0 1-1.8 0v-.232c0-.553.245-.996.51-1.312.26-.311.58-.55.847-.723a.94.94 0 0 0 .421-.793c0-.537-.416-.929-.877-.929m1.2 6.966a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0" />
      <path
        fillRule="evenodd"
        d="M12 3.1a8.9 8.9 0 1 0 0 17.8 8.9 8.9 0 0 0 0-17.8M4.9 12a7.1 7.1 0 1 1 14.2 0 7.1 7.1 0 0 1-14.2 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcQuestionCircleSmallRegular;
